import { useLayoutEffect, useState } from 'react'

/** Half-screen / split view on Mac — show resume preview only (no sidebar, no editor). */
export const RESUME_PREVIEW_ONLY_BREAKPOINT_PX = 1200

export function isResumePreviewOnlyWidth(widthPx: number): boolean {
  return widthPx > 0 && widthPx < RESUME_PREVIEW_ONLY_BREAKPOINT_PX
}

export function useResumePreviewOnlyMode(): boolean {
  const [previewOnly, setPreviewOnly] = useState(() =>
    typeof window !== 'undefined' ? isResumePreviewOnlyWidth(window.innerWidth) : false
  )

  useLayoutEffect(() => {
    const update = () => setPreviewOnly(isResumePreviewOnlyWidth(window.innerWidth))
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return previewOnly
}
